"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import { useSeizeConnectContext } from "@/components/auth/SeizeConnectContext";
import CommonInfoBox from "@/components/utils/CommonInfoBox";
import { RateMatter } from "@/enums";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
import { ApiProfileProxyActionType } from "@/generated/models/ApiProfileProxyActionType";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
import { amIUser } from "@/helpers/Helpers";
import { useContext, useEffect, useState } from "react";
const SUB_TITLE: Record<RateMatter, string> = {
  [RateMatter.NIC]: "NIC rate",
  [RateMatter.REP]: "give Rep for",
  [RateMatter.DROP_REP]: "give Drop Rep for"
};
enum RaterContext {
  NOT_CONNECTED = "NOT_CONNECTED",
  DONT_HAVE_PROFILE = "DONT_HAVE_PROFILE",
  PROXY_NO_ALLOWANCE = "PROXY_NO_ALLOWANCE",
  PROXY_GRANTOR_PROFILE = "PROXY_GRANTOR_PROFILE",
  MY_PROFILE = "MY_PROFILE",
  CAN_RATE = "CAN_RATE",
}
export default function UserPageRateWrapper(t0) {
  const $ = _c(27);
  const {
    profile,
    type,
    children
  } = t0;
  const {
    address
  } = useSeizeConnectContext();
  const {
    activeProfileProxy,
    connectedProfile
  } = useContext(AuthContext);
  let t1;
  if ($[0] !== activeProfileProxy?.actions || $[1] !== type) {
    t1 = () => {
      switch (type) {
        case RateMatter.NIC:
          {
            return !!activeProfileProxy?.actions.find(_temp);
          }
        case RateMatter.REP:
          {
            return !!activeProfileProxy?.actions.find(_temp2);
          }
        case RateMatter.DROP_REP:
          {
            return false;
          }
        default:
          {
            assertUnreachable(type);
            return false;
          }
      }
    };
    $[0] = activeProfileProxy?.actions;
    $[1] = type;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const getIsProxyAndHaveAllowance = t1;
  let t2;
  if ($[3] !== activeProfileProxy || $[4] !== address || $[5] !== connectedProfile || $[6] !== getIsProxyAndHaveAllowance || $[7] !== profile) {
    t2 = () => {
      if (!connectedProfile) {
        return RaterContext.NOT_CONNECTED;
      }
      if (!activeProfileProxy && amIUser({
        profile,
        address
      })) {
        return RaterContext.MY_PROFILE;
      }
      if (!connectedProfile.handle) {
        return RaterContext.DONT_HAVE_PROFILE;
      }
      if (!!activeProfileProxy && !getIsProxyAndHaveAllowance()) {
        return RaterContext.PROXY_NO_ALLOWANCE;
      }
      if (!!activeProfileProxy && activeProfileProxy.created_by.handle === profile.handle) {
        return RaterContext.PROXY_GRANTOR_PROFILE;
      }
      return RaterContext.CAN_RATE;
    };
    $[3] = activeProfileProxy;
    $[4] = address;
    $[5] = connectedProfile;
    $[6] = getIsProxyAndHaveAllowance;
    $[7] = profile;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const getRaterContext = t2;
  let t3;
  if ($[9] !== profile || $[10] !== type) {
    t3 = context => {
      switch (context) {
        case RaterContext.NOT_CONNECTED:
          {
            return `Please connect to ${SUB_TITLE[type]} ${profile.query}`;
          }
        case RaterContext.DONT_HAVE_PROFILE:
          {
            return `Please make profile to ${SUB_TITLE[type]} ${profile.query}`;
          }
        case RaterContext.PROXY_NO_ALLOWANCE:
          {
            return `You are acting as proxy and don't have allowance to ${SUB_TITLE[type]} ${profile.query}`;
          }
        case RaterContext.PROXY_GRANTOR_PROFILE:
          {
            return `You are acting as proxy and can't ${SUB_TITLE[type]} proxy grantor profile`;
          }
        case RaterContext.MY_PROFILE:
          {
            return `You can't ${SUB_TITLE[type]} your own profile`;
          }
        case RaterContext.CAN_RATE:
          {
            return null;
          }
      }
    };
    $[9] = profile;
    $[10] = type;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const getRaterContextMessage = t3;
  let t4;
  if ($[12] !== getRaterContext) {
    t4 = getRaterContext();
    $[12] = getRaterContext;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const [raterContext, setRaterContext] = useState(t4);
  const [raterContextMessage, setRaterContextMessage] = useState(getRaterContextMessage(raterContext));
  let t5;
  if ($[14] !== getRaterContext || $[15] !== getRaterContextMessage) {
    t5 = () => {
      const context_0 = getRaterContext();
      setRaterContext(context_0);
      setRaterContextMessage(getRaterContextMessage(context_0));
    };
    $[14] = getRaterContext;
    $[15] = getRaterContextMessage;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== activeProfileProxy || $[18] !== address || $[19] !== connectedProfile || $[20] !== profile || $[21] !== type) {
    t6 = [connectedProfile, activeProfileProxy, address, profile, type];
    $[17] = activeProfileProxy;
    $[18] = address;
    $[19] = connectedProfile;
    $[20] = profile;
    $[21] = type;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  useEffect(t5, t6);
  if (raterContextMessage) {
    let t7;
    if ($[23] !== raterContextMessage) {
      t7 = <CommonInfoBox message={raterContextMessage} />;
      $[23] = raterContextMessage;
      $[24] = t7;
    } else {
      t7 = $[24];
    }
    return t7;
  }
  let t7;
  if ($[25] !== children) {
    t7 = <>{children}</>;
    $[25] = children;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  return t7;
}
function _temp2(action) {
  return action.action_type === ApiProfileProxyActionType.AllocateRep;
}
function _temp(action_0) {
  return action_0.action_type === ApiProfileProxyActionType.AllocateCic;
}